import React,{useEffect} from 'react';
import './index.scss';


import logo from "../../assets/img/logo-bg.png";
import Button from "../../common/Button";
import axios from 'axios';
import { useState } from "react";
import MSGDialogue from '../../components/Dialogue';
import {APIurl,rootUrl,callcookie, getCookie} from '../../App';
import globe from "../../assets/img/desktop-globe.avif";


import { Container, Form } from 'react-bootstrap';

export default function Landing(props){

    
const [openFaq, setOpenFaq] = useState(false);

     

  

        return(
            <>   
            <Container fluid className="landing-wrapper bg-white h-100 pt-3">
               <div className="container top-buttons d-flex flex-row ">
    <Button
        title="Dashboard Login"
        active="btn-deactive font-weight-bold"
        path="/login"
        icon="fa fa-arrow-right ml-2"
    />
   
</div>

            {/* Main Content */}
            <div className="hero-container">
                
                <div className="hero-logo">
                    <img src={logo} alt="EATrade Logo" />
                </div>

                <div className="hero-content">
                    <h1>Mobile EA Hosting Service</h1>

                    <p className="hero-description">
                        Powerful trading automation on-the-go. Host your Expert Advisors (EAs) on mobile for seamless trading with low latency and 24/7 uptime.
                    </p>

                    <div className="hero-buttons">
                        <a href="#" className="pill-btn android">
                            <i className="fa fa-android mr-2 fs-4"></i>
                            Get Android Now
                        </a>
                        <a href="#" className="pill-btn ios">
                            <i className="fa fa-apple mr-2 fs-4"></i>
                            Get iOS Now
                        </a>
                    </div>

                    <p className="hero-trust">
                        <strong>100% EA execution guarantee | 4.8/5 from 300+ reviews</strong>
                    </p>
                </div>

            </div>
{/* WHY CHOOSE EA TRADE */}
<div className="why-eatrade">

    <h2 className="why-title">Why Choose EA Trade?</h2>

    <div className="why-cards">

        {/* Card 1 */}
        <div className="why-card">
            <i className="fa fa-bolt why-icon"></i>
            <h4>Low Latency</h4>
            <p>
                Execute trades with minimal delay, as low as 1ms, for precise market entry.
            </p>
        </div>

        {/* Card 2 */}
        <div className="why-card">
            <i className="fa fa-shield why-icon"></i>
            <h4>Secure Hosting</h4>
            <p>
                Advanced cybersecurity protects your trading data from threats.
            </p>
        </div>

        {/* Card 3 */}
        <div className="why-card">
            <i className="fa fa-clock-o why-icon"></i>
            <h4>24/7 Uptime</h4>
            <p>
                Keep your EAs running continuously with our reliable servers.
            </p>
        </div>

    </div>

</div>
{/* VALUE SECTIONS */}
<div className="value-sections">

    {/* Item 1 */}
    <div className="value-card">
        <h3>Years of Happy Traders</h3>
        <p>
            EA Trade has empowered traders with reliable mobile hosting solutions,
            earning trust and recognition for innovation and excellence in the
            trading community.
        </p>
        <i className="fa fa-trophy value-icon"></i>
    </div>

    {/* Item 2 */}
    <div className="value-card">
        <h3>No More Freezes on News Release</h3>
        <p>
            High-impact news can freeze your trading platform, costing you profits.
            EA Trade reserves a resource buffer to ensure your mobile EAs stay active
            during volatile market conditions.
        </p>
        <i className="fa fa-shield value-icon theme-color"></i>
    </div>

    {/* Item 3 */}
    <div className="value-card">
        <h3>Cutting-Edge Cybersecurity</h3>
        <p>
            Real-time monitoring and anti-DDoS solutions protect your mobile EA
            hosting from volumetric and protocol-based attacks, keeping your
            trading data secure.
        </p>
        <i className="fa fa-lock value-icon"></i>
    </div>

    {/* Item 4 */}
    <div className="value-card">
        <h3>We’re Here For You 24/7</h3>
        <p>
            Our dedicated support team is available around the clock to assist
            with any issues. Meet our experts ready to help you succeed in your
            trading.
        </p>
        <i className="fa fa-user value-icon"></i>
    </div>

</div>
{/* HOW TO SETUP VPS */}
<div className="setup-vps">

    <h1 className="setup-title">How to Setup Your Mobile VPS!</h1>

    <p className="setup-description">
        A virtual private server you can access from your phone or tablet,
        designed to run your trading software continuously. It hosts your
        Expert Advisors, so they operate 24/7 without depending on your device.
        Start and stop your robot right from your phone—anywhere, anytime.
    </p>

    {/* STEPS */}
    <div className="setup-cards">

        <div className="setup-card">
            <div className="step-circle">1</div>
            <strong>Buy EA Trade Access from R600 (36.6$)</strong>
        </div>

        <div className="setup-card">
            <div className="step-circle">2</div>
            <strong>Buy your license key from a mentor</strong>
        </div>

        <div className="setup-card">
            <div className="step-circle">3</div>
            <strong>
                Link your EA on the EA Trade VPS and link your Meta Trade (MT) account
            </strong>
        </div>

    </div>

    {/* FEATURES */}
    <div className="setup-features">
        <ul>
            <li><i className="fa fa-check"></i> Accurate Execution</li>
            <li><i className="fa fa-check"></i> Ultra Low 1 millisecond latency</li>
            <li><i className="fa fa-check"></i> MT4/MT5 Supported</li>
            <li><i className="fa fa-check"></i> Unlimited Access</li>
        </ul>
    </div>

</div>
{/* ACTIVE WORLDWIDE */}
<div className="active-worldwide">

    <h1 className="worldwide-title">Active Worldwide</h1>

    <div className="worldwide-image">
        <img
            src={globe}
            alt="EA Trade Global Coverage"
        />
    </div>

    <p className="worldwide-text">
        Connected across 905 global points, ensuring low-latency trading worldwide.
    </p>

</div>

{/* FAQ SECTION */}
<div className="faq-section">

    <h1 className="faq-title">Have Some Questions?</h1>

    <div className="faq-card">

        <div
            className="faq-header"
            onClick={() => setOpenFaq(!openFaq)}
        >
            <span className="faq-question">
                How does a VPS work?
            </span>

            <i
                className={`fa fa-angle-down faq-icon ${openFaq ? "rotate" : ""}`}
            ></i>
        </div>

        {openFaq && (
            <div className="faq-body">
                <p>
                    A virtual private server is a dedicated virtual computer or a
                    dedicated server you can rent to keep your trading activities
                    running continuously without interruption. Unlike a regular
                    home computer, a Forex VPS is housed in a data center, providing
                    high-speed internet and protection from power outages. This
                    setup ensures your trading platform stays active and reliable,
                    even if you experience local internet or power disruptions.
                    You can learn more from this guide.
                </p>
            </div>
        )}

    </div>

</div>

{/* FOOTER */}
<footer className="site-footer">
    <p>
        © EATrade.co.za {new Date().getFullYear()}. All Rights Reserved.
    </p>
</footer>
            {/* Floating WhatsApp */}
            <a
                href="https://wa.me/27626539981"
                target="_blank"
                rel="noopener noreferrer"
                className="floating-whatsapp"
            >
                <i className="fa fa-whatsapp"></i>
            </a>

            {/* Floating Email */}
            <a
                href="mailto:support@eatrade.co.za"
                className="floating-email"
            >
                Message us
            </a>

        </Container>
            </>
        )
        ;
    

  

}